module.exports = __webpack_public_path__ + "static/xero-logo-1f8891bb2595ea5adcb30b2b52dcbaa7.png";